"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sc = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getStylesFromComponent = function getStylesFromComponent(props, styles) {
  if (typeof styles === 'function') {
    return styles(props);
  }

  return styles;
};

var getStylesFromProps = function getStylesFromProps(props, componentName) {
  var _props$$styled;

  var styles = (_props$$styled = props.$styled) === null || _props$$styled === void 0 ? void 0 : _props$$styled[componentName];

  if (styles) {
    return getStylesFromComponent(props, styles);
  }

  return "";
};

var getAttrs = function getAttrs(displayName) {
  return function (props) {
    var _props$$classNames;

    return {
      className: "".concat(((_props$$classNames = props['$classNames']) === null || _props$$classNames === void 0 ? void 0 : _props$$classNames[displayName]) || '')
    };
  };
};

var getStyles = function getStyles(styles, displayName) {
  return function (props) {
    return (0, _styledComponents.css)(_templateObject(), getStylesFromComponent(props, styles), getStylesFromProps(props, displayName));
  };
};

var sc = function sc(component) {
  return function (styles) {
    return function (displayName) {
      return (0, _styledComponents["default"])(component).withConfig({
        displayName: displayName
      }).attrs(getAttrs(displayName)).withConfig({
        componentId: "n7m35v-0"
      })(getStyles(styles, displayName));
    };
  };
};

exports.sc = sc;